import PropTypes from 'prop-types'
import React from 'react'
import SimpleReactModal from 'simple-react-modal'
import classNames from 'classnames'

import SvgIcon from 'components/common/SvgIcon'

import styles from './hobnob-modal.scss'
import CancelIcon from 'src/assets/icons/cancel-icon.svg'

export default class HobnobModal extends React.Component {
  _onClose = (e) => {
    e.preventDefault()
    this.props.onClose(e)
  }

  render () {
    const {
      cancelButtonInContainer,
      containerClassName,
      show,
      style,
      onClose,
      title,
      subTitle,
      contentClassName,
      showCancelIcon,
      closeOnOuterClick
    } = this.props
    const cancelButtonContainerStyles = cancelButtonInContainer ? 'cancel-button-container' : ''
    const defaultContainerStyles = {
      padding: '10px 10px 30px',
      borderRadius: '10px',
      margin: '10vh auto 5px',
      width: '90vw',
      maxWidth: '500px'
    }

    // Keep in sync with HobnobHud
    const modalStyle = {
      transition: 'opacity 0.25s ease-in-out',
      background: 'rgba(0, 0, 0, 0.4)',
      fontFamily: null,
      ...style
    }

    const containerStyles = {
      ...defaultContainerStyles,
      ...this.props.containerStyles
    }

    return (
      <SimpleReactModal
        show={show}
        onClose={onClose}
        style={modalStyle}
        containerClassName={containerClassName}
        containerStyle={containerStyles}
        // transitionSpeed={250}
        closeOnOuterClick={closeOnOuterClick}
      >
        {
          showCancelIcon
            ? <div className={classNames(styles[cancelButtonContainerStyles], styles['cancel-icon-wrapper'])}>
              <SvgIcon className={styles['cancel-icon']} icon={CancelIcon} padding='5px' onClick={this._onClose} />
            </div>
            : null
        }

        <div className={classNames(styles['content'], contentClassName)}>
          {title ? <h2 className={styles['title']}>{title}</h2> : null}
          {subTitle ? <div>{subTitle}</div> : null}
          {this.props.children}
        </div>
      </SimpleReactModal>
    )
  }
}

HobnobModal.propTypes = {
  cancelButtonInContainer: PropTypes.bool,
  containerClassName: PropTypes.string,
  containerStyles: PropTypes.object,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  style: PropTypes.object,
  subTitle: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  contentClassName: PropTypes.string,
  showCancelIcon: PropTypes.bool,
  closeOnOuterClick: PropTypes.bool
}
HobnobModal.defaultProps = {
  cancelButtonInContainer: false,
  showCancelIcon: true,
  closeOnOuterClick: true
}



// WEBPACK FOOTER //
// ./src/components/common/HobnobModal.jsx